import script from "./SizeChartView.vue?vue&type=script&setup=true&lang=js"
export * from "./SizeChartView.vue?vue&type=script&setup=true&lang=js"

import "./SizeChartView.vue?vue&type=style&index=0&id=61498228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61498228"]])

export default __exports__